export const FaqData = [
  {
    question: "What is the ERC Webwellet?",
    answer: "It's a crypto wallet for managing Emission Reduction Coins.",
  },
  {
    question: "What are Emission Reduction Coins (ERCs)?",
    answer:
      "ERCs are blockchain tokens representing verified carbon emission reductions.",
  },
  {
    question: "Is the ERC Webwellet secure?",
    answer:
      "Yes, it uses blockchain and encryption technology for safe and transparent transactions.",
  },

  {
    question: "Can I transfer ERCs to other wallets?",
    answer:
      " Absolutely. You can send and receive ERCs instantly with other compatible wallets.",
  },
  {
    question: "Who can use the ERC Webwellet?",
    answer:
      "Anyone interested in sustainability and carbon trading can use the wallet globally.",
  },
  {
    question: "Is the wallet free to use?",
    answer:
      "Yes, creating and using the ERC Webwellet is completely free with no hidden fees",
  },
];
